import { useQuery } from '@tanstack/react-query';

import { useEmailApiClient } from '@/api/clients/useEmailApiClient.util.ts';
import { ResourceIdDto, ResourceTypeDto } from '@/api/generated';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import { useUserContext } from '@/contexts/userContext/User.context.ts';
import { useNewEmailStore } from '@/views/emails/context/NewEmails.store.ts';

type Return = { processResource: ResourceIdDto | null };

export const useResolveProcessResource = (): Return => {
  const { emailReaderApi } = useEmailApiClient();
  const { userId } = useUserContext();

  const directResource = useNewEmailStore(state => state.newEmailState?.resource);
  const sourceEmailThreadId = useNewEmailStore(state => state.newEmailState?.email?.threadId);

  const directHit = directResource?.type === ResourceTypeDto.Process ? directResource : null;

  const enabled = !directHit && Boolean(sourceEmailThreadId);

  const { data: thread } = useQuery({
    enabled,
    queryFn: async () => {
      const { data } = await emailReaderApi.readThread(userId, sourceEmailThreadId!);
      return data;
    },
    queryKey: [QueryKeyEnum.EMAILS.THREAD, sourceEmailThreadId],
  });

  if (directHit) {
    return { processResource: directHit };
  }

  const fromThread = thread?.resourceIds.find(r => r.type === ResourceTypeDto.Process);
  return { processResource: fromThread ?? null };
};
